export default __webpack_public_path__ + "static/media/videobg.2e60810c.png";